<template>
    <div>
        <rkm-area title="Telefones">
            <template slot="trailing">
                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                    small
                    title="Adicionar telefone"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>

            <List :data="data" />
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true }
    },
    methods: {
        async validate() {

            if (this.data.model.telefones.length === 0) {

                this.showValidationNotification('Obrigatório incluir pelo menos um telefone.')

                return false
            }

            return true
        }
    }
}
</script>